import styled from 'styled-components';

export const HeaderContainer = styled.div`
    display: block;
    position: relative;
    width: 100%;
`;


